import styled from '@emotion/styled';
import Card from '@/components/Card';

const EditorCard = styled(Card)({
  display: 'flex',
});

export default EditorCard;
